import { AbButton } from "../button/button.widget.js";
import { uuid } from "../../utils/random-utils.js";
import { appContext } from "../../badge2.context.js";
import { ResponsivenessService } from "../../domain/responsiveness.service.js";
import { BaseComponent } from "../../base.component.js";
import { nodeOffset } from '../../utils/dom-utils.js';

/**
 * @typedef {RenderableProps} _AbMenu_Props
 * @property {'internal'|'external'} [placement = 'external']
 * @property {any} [customButtons]
 * @property {number} [popupOffsetRight] px, if needed
 */

export class AbMenu extends BaseComponent {

  /** @type {ResponsivenessService} */
  _responsivenessService;
  /**
   * @param {_AbMenu_Props} props
   */
  constructor(props) {
    super(props);
    this._responsivenessService = appContext.obtain(ResponsivenessService);
    this.state = {
      isOpen: false,
      vertPos: "top",
      horizPos: "left",
      compId: `C${uuid()}`
    };
  }

  ref;
  height = 96;
  width = 180;
  setRef(ref) {
    this.ref = ref;
  }

  /**
   * @private
   * @param {boolean} isOpen
   */
  _setMenuOpen(isOpen) {
    if (isOpen) {
      this._responsivenessService.onClickOutside(this, () => this._setMenuOpen(false));
    }
    this.setState({ ...this.state, isOpen });
    if (isOpen) {
      const menuPosition = nodeOffset(this.ref, true);
      // check if it fits vertically
      const newVertPos = menuPosition.top < this.height ? "bottom" : "top";
      if (this.state.vertPos !== newVertPos) {
        this.setState({ vertPos: newVertPos });
      }
      // check if it fits horizontally
      const newHorizPos = menuPosition.left < this.width ? "right" : "left";
      if (this.state.horizPos !== newHorizPos) {
        this.setState({ horizPos: newHorizPos });
      }
    }
  }

  toggleMenu() {
    this._setMenuOpen(!this.state.isOpen);
  }

  minimize() {
    this._setMenuOpen(false);
  }

  /**
   * @param {_AbMenu_Props} props
   * @param {object} state
   * @param {_AbComponent_Context} ctx
   * @returns {ComponentChild}
   */
  render = (props, state, ctx) => {
    const { placement = 'external', children } = props;

    const positionClasses = placement === 'internal' ? '' : `${this.state && this.state.vertPos && ("ab-menu-popup-" + this.state.vertPos)} ${this.state && this.state.horizPos && ("ab-menu-popup-" + this.state.horizPos)}`;

    return (
      <div className={`ab-menu ab-${placement}`} ref={this.setRef.bind(this)} style={{
        zIndex: ctx.composition.parts.menu.zIndex
      }}>
        <div className="ab-buttons">
          <div className="ab-menu-button">
            <AbButton type="icon" icon="dots.svg" onClick={() => this.toggleMenu()} />
          </div>
          {props.customButtons}
        </div>
        <div className={`ab-menu-popup ${positionClasses}`} style={{
          display: state.isOpen ? 'flex' : 'none',
          zIndex: ctx.composition.parts.menu.zIndex,
          marginRight: `${props.popupOffsetRight || 0}px`
        }}>
          <div className="ab-menu-contents">
            <div className="ab-menu-close">
              <AbButton type="icon" icon="close-icon.svg" onClick={() => this.minimize()} />
            </div>
            {children}
          </div>
          <div className="ab-menu-arrow" />
        </div>
      </div>
    );
  };
}
